// extracted by css-extract-rspack-plugin
export default {"Box":"automation-graph-module__Box__bAPJq"};